import ReviewerRole from './ReviewerRole'

export default class DevReviewer extends ReviewerRole {
  arcDownloadsPerWeek = -1
  totalClaimOverdueDayAllowance = -1
  arcMaxDownloads = -1
  requiredReviewsForTier = 100000
  requiredReviewRateForTier = 101
}
